import { render } from "./EmailModal.vue?vue&type=template&id=0d17ded5&scoped=true"
import script from "./EmailModal.vue?vue&type=script&lang=js"
export * from "./EmailModal.vue?vue&type=script&lang=js"

import "./EmailModal.vue?vue&type=style&index=0&id=0d17ded5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d17ded5"]])

export default __exports__